import { firebaseDatabase } from "config/index";

export const getDocumentFirebaseDB = async (url) => {
  try {
    const promise = new Promise((res, rej) =>
      firebaseDatabase.ref(url).once(
        "value",
        (snapshot) => res(snapshot.val()),
        (error) => rej(error)
      )
    );
    const result = await promise;
    return { error: false, response: result };
  } catch (error) {
    return { error: true, response: error };
  }
};

export const addFirtsChildDB = async (url, data) => {
  try {
    const child = await firebaseDatabase.ref(url).update(data);
    return { error: false, response: child };
  } catch (error) {
    return { error: true, response: error };
  }
};
